<template functional>
    <div :id="data.id" :class="['address-line', { 'inline': props.inline }, data.class, data.staticClass]" :style="data.style" v-bind="data.attrs">
        <template v-if="Object.keys(props.address).length > 0">{{ props.address.locationName }}<br /></template>
        <template v-if="Object.keys(props.address).length > 0">{{ props.address.firstname }} {{ props.address.lastname }}<br /></template>
        <template v-if="Object.keys(props.address).length > 0">{{ props.address.street }}<br /></template>
        <template v-if="Object.keys(props.address).length > 0">{{ props.address.zip }} {{ props.address.city }}</template>
    </div>
</template>

<script>
export default {
    name: 'AddressLine',
    props: {
        address: {
            type: Object,
            default: () => ({})
        },
        inline: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
$addressline-padding-y: $spacer * 0.5 !default;
$addressline-padding-x: 0 !default;
$addressline-border: $border-width solid $border-color !default;

.address-line {
    padding: $addressline-padding-y $addressline-padding-x;
    border-top: $addressline-border;
    border-bottom: $addressline-border;

    + .address-line {
        margin-top: nth($addressline-border, 1) * -1;
    }

    &.inline {
        padding: 0;
        border: 0 none;

        + .address-line {
            margin-top: 0;
        }
    }
}
</style>
